import { useState } from "react";
import "@/App.css";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/components/Login";

// Import your app components
import Sidebar from "@/components/Sidebar";
import CallPanel from "@/components/CallPanel";
import ContactList from "@/components/ContactList";
import CallHistory from "@/components/CallHistory";
import Settings from "@/components/Settings";
import IncomingCallModal from "@/components/IncomingCallModal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "") || "";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const AppLayout = () => {
  const [currentPage, setCurrentPage] = useState("atendimento");
  const { logout } = useAuth();

  return (
    <div className="flex h-screen bg-slate-50">
      <Sidebar 
        currentPage={currentPage} 
        setCurrentPage={setCurrentPage} 
        onLogout={logout} 
      />
      <main className="flex-1 overflow-auto">
        <div className={currentPage === "atendimento" ? "h-full" : "hidden"}>
          <CallPanel isActive={currentPage === "atendimento"} />
        </div>
        {currentPage === "agenda" && <ContactList />}
        {currentPage === "historico" && <CallHistory />}
        {currentPage === "configuracoes" && <Settings />}
      </main>
      <IncomingCallModal />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <HashRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<AppLayout />} />
              <Route path="/dashboard" element={<AppLayout />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </HashRouter>
    </div>
  );
}

export default App;